import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  connect() {
    const openHandler = function (event) {
      if (event.target.classList.contains('loaded')) {
        return false
      }
      Rails.ajax({
        type: "get",
        dataType: "script",
        url: event.target.dataset.url,
        error: function () {
          alert('エラーが発生しました。');
        }
      })
      console.log(event.target.dataset.url);
    };

    document.querySelectorAll('.accordion-collapse').forEach(function (button) {
      button.addEventListener('shown.bs.collapse', openHandler);
    });

    // 条件分岐を追加して、要素が存在する場合のみクリックを実行
    const accordionButton = document.querySelector('.accordion-button');
    if (accordionButton) {
      accordionButton.click();
    } else {
      console.warn("Accordion button not found.");
    }
  }
}